import { requester } from "App";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useParams } from "react-router-dom";
import homeBtnIcon from "resources/img/puffu/homebtn.svg";
import { motion, AnimatePresence } from "framer-motion";
import { useTouchClick } from "shared/hooks/useTouchClick";
import categorySound from "resources/music/물방울.mp3";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import style from "./BrandCard.module.css";




function BrandCard(props) {

    const { vertical, horizontal, setBrandVisible, setShowExhibition, data, setFilteredProducts, setBrands, showBrandProducts, setShowBrandProducts, setSelectedCategory, setViewData, currentBrandPage, setCurrentBrandPage } = props;
    const audioRef = useRef();
    const { id } = useParams();
    const brandClick = () => {
        audioRef.current.play();
        let brandData = {
            storeCode: id,
            brandId: data.id
        }
        dispatch(HistoryReducer.actions.setLoading(true));
        setFilteredProducts([]);
        setBrandVisible(true)
        requester.findAllProductsByBrand(brandData, (result) => {
            if (result.data) {
                setFilteredProducts(result.data)

                setBrands([]);
                setShowBrandProducts(false)
            }
            else {
                setFilteredProducts([])
            }
        })
        dispatch(HistoryReducer.actions.setLoading(false));
        setViewData((prevData) => ({
            ...prevData,
            view: "BrandProductList",
            currentBrandPage: currentBrandPage
        }));
    }
    const { isLoading, isBrandLoading } = useSelector((state) => ({
        isLoading: state.history.isLoading,
        isBrandLoading: state.history.isBrandLoading
    }));
    const dispatch = useDispatch();


    const { handleTouchStart: brandTouchStart, handleTouchEnd: brandTouchEnd } = useTouchClick(brandClick, 10);

    return (

        <div

            onPointerDown={brandTouchStart}
            onPointerUp={brandTouchEnd}
            className={style.brandCard}
            style={{
                display: "flex",
                flex: horizontal ? "1 0 30%" : "1 0 40%",
                justifyContent: "center",
                alignItems: "center",
                height: vertical ? null : "340px"
            }}
        >
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <VerticalFlex>
                <FlexChild borderRadius={"3px"}>
                    <img src={data.brandImg && data.brandImg} width={"100%"} height={vertical ? null : "223px"} />
                </FlexChild>
                <FlexChild border={"1px solid rgba(165, 165, 165, 1)"} backgroundColor={"white"}>
                    <HorizontalFlex width={"95%"}>
                        <FlexChild width={"85%"}>
                            <VerticalFlex flexStart>
                                <FlexChild>

                                    <P color={"rgba(0, 0, 0, 1)"}>{data.contents && data.contents}</P>
                                </FlexChild>
                                <FlexChild>
                                    <P color={"rgba(0, 0, 0, 1)"} size={horizontal ? "2vw" : "3vw"} weight={700}>{data.brandName && data.brandName}</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <img src={homeBtnIcon} width={"40px"} style={{ transform: "rotate(180deg)" }} />
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </div>

    );
}

export default BrandCard;